import React, { useState } from "react";
import SchoolMS_FAQs from "../../ServiceDetails/Faq/Faq"


const AccordionItem = ({ question, answer, isOpen, onClick }) => {
    return (
      <div className="accordion-item">
        <div className="accordion-header" id={question}>
          <button
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}
            type="button"
            onClick={onClick}
            aria-expanded={isOpen}
            aria-controls={question}
          >
            <span className="title">{question}</span>
          </button>
        </div>
        <div
          id={question}
          className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
          aria-labelledby={question}
        >
          <div className="accordion-body">{answer}</div>
        </div>
      </div>
    );
  };

const SchoolMS_FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

  const items = [
    {
      question: "What is Hisab Book?",
      answer:
        "Hisab Book is a digital ledger and accounting app that helps manage transactions, track finances, and streamline business operations with ease.",
    },
    {
      question: "Is Hisab Book suitable for small businesses?",
      answer:
        "Yes, Hisab Book is designed to meet the needs of both small businesses and large enterprises, offering simple yet powerful financial tracking tools.",
    },
    {
      question: "Can I backup my data on Hisab Book?",
      answer:
        "Yes, Hisab Book allows you to securely back up your data and restore it anytime to ensure your financial records are safe.",
    },
    {
      question: "Does Hisab Book offer multi-language support?",
      answer:
        "Yes, Hisab Book supports multiple languages, ensuring a user-friendly experience for diverse users across different regions.",
    },
    {
      question: "Is my financial data secure in Hisab Book?",
      answer:
        "Absolutely! Hisab Book uses advanced encryption and security protocols to keep your financial data protected from unauthorized access.",
    },
  ];

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
    

  return (
    <div className="section harsafe-choose-us-section-02 section-padding">
      <div className="container">
        {/* <!-- Pricing Wrap Start --> */}
        <div className="pricing-wrap">
          <div className="section-title text-center">
            <h3 className="sub-title">FAQ</h3>
            <h2 className="title">FAQ's</h2>
          </div>
          <div className="pricing-content-wrap">
            <div className="col-lg-8 col-md-12 m-auto">

              <div className="choose-us-right">
                <div className="faq-accordion">
                  <div className="accordion" id="accordionExample">
                    {items.map((item, index) => (
                      <AccordionItem
                        key={index}
                        question={item.question}
                        answer={item.answer}
                        isOpen={activeIndex === index}
                        onClick={() => handleClick(index)}
                      />
                    ))}
                  </div>
                </div>
              </div>
              

            </div>
          </div>
        </div>
        {/* <!-- Pricing Wrap End --> */}
      </div>
    </div>
  )
}

export default SchoolMS_FAQ